/* LogLevels.js */

"use strict";

module.exports.LOG_LEVELS = {
    EVENT: {notation: "."},
    ABORT: {notation: "??"},
    STARTLOG: {notation: ""},
    INFO: {notation: "."},
    CHECKPOINT: {notation: "(*)"},
    TASK: {notation: {start: ">>", end: "<<"}},
    DEBUG: {notation: "__"},
    WARNING: {notation: "!?"},
    ERROR: {notation: "??"},
    EXCEPTION: {notation: "??"},
    RESPONSE: {notation: "}"},
    FINISHLOG: {notation: ""},
    KILLED: {notation: "XX"},
};
